export enum SkuResourcesEditorTab {
	Skus = 'SkusView',
	Resources = 'ResourcesView',
}
